import React, { Component } from "react";
import axios from "axios";
import { Link, NavLink } from "react-router-dom";
import tileIcon from "../../../../src/assets/images/tiles_icon.png";
import listIcon from "../../../../src/assets/images/list_icon.png";
import "./PaginationList.css";
import MiniAudioPlayer from "../MiniAudioPlayer";
import Spinner from "react-spinner";
import Helpers from "../../Helpers";

export default class PaginationList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      counter: this.props.items_per_page ? this.props.items_per_page : null,
      counterX: 0,
      pagination_list: this.props.pagination_list,
      morePagination: "",
      displayType: this.props.view_type,
      loading: false,
      sortedBy: false,
      sortType: this.props.sortType ? this.props.sortType : "",
      activeAudioIndex: null, // <-- DODANE: śledzimy aktywny odtwarzacz
    };
  }

  // <-- DODANE: Metoda do aktualizacji aktywnego indeksu audio
  handleAudioPlay = (index) => {
    this.setState({ activeAudioIndex: index });
  };

  updateHandler = () => {
    this.setState({ loading: true });
    this.updateList(true);
  };

  componentDidUpdate(prevProps) {
    if (this.props.sortType !== prevProps.sortType) {
      this.setState(
        {
          ...this.state,
          loading: true,
          pagination_list: [],
          sortType: this.props.sortType,
        },
        () => {
          this.updateList(false);
        }
      );
    }
    const url = new URL(window.location.href);
    const searchParam = url.searchParams.get("search");
    if (searchParam) {
      const texts = document.querySelectorAll(".col-lg-12.custom-text");
      texts.forEach((item) => {
        let array = [];

        item = item.children[0];

        if (item.dataset.customedit !== "true") {
          item.innerHTML = item.innerText;

          const regEx1 = new RegExp(searchParam, "ig");
          const replaceMask = searchParam;

          item.innerHTML = item.innerHTML.replace(regEx1, replaceMask);
          array = item.innerHTML.split(searchParam);

          let originalString = array[0].replace(/(<([^>]+)>)/gi, " ");
          let originalString2 = array[1]
            ? array[1].replace(/(<([^>]+)>)/gi, " ")
            : "";
          let originalString3 = item.innerHTML.replace(/(<([^>]+)>)/gi, " ");

          if (array.length && array.length > 1) {
            item.innerHTML =
              "..." +
              originalString.slice(
                originalString.length - 100,
                originalString.length
              ) +
              `<span style="background: yellow">${searchParam}</span>` +
              originalString2.slice(0, 300) +
              "...";
          } else {
            item.innerHTML = originalString3.substring(0, 220) + "...";
          }
        }

        item.dataset.customedit = "true";
      });
    }
  }

  sortUpdate = (e) => {
    this.setState(
      {
        ...this.state,
        loading: true,
        pagination_list: [],
        sortType: e.currentTarget.value,
      },
      () => {
        this.updateList(false);
      }
    );
  };

  updateList = (rise) => {
    if (rise) {
      this.setState(
        () => {
          return {
            ...this.state,
            counterX: (this.state.counterX += 1),
            loading: true,
          };
        },
        () => this.updateData()
      );
    } else {
      this.updateData();
    }
  };

  updateData = () => {
    let offset = this.props.items_per_page;
    let counter = this.state.counterX;
    let link = `${this.props.button_lazy_load.url}${this.state.counter}?lang=${
      this.props.button_lazy_load.lang
    }&offset=${offset * this.state.counterX}&sort=${this.state.sortType}`;

    axios
      .post(link, "search=" + sessionStorage.getItem("OptSearch"))
      .then((res) => {
        const data = res.data.pagination_list;
        if (data.length) {
          this.setState({
            ...this.state,
            pagination_list: this.state.pagination_list.concat(data),
          });
          this.setState({ loading: false });
        }
        if (data.length < this.props.items_per_page) {
          this.setState({
            morePagination: "no-more-data",
          });
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        this.setState({
          isVisible: false,
        });
      });
  };

  createMarkup(item) {
    return { __html: item };
  }

  sort = (e) => {
    this.sortList(e.currentTarget.value, this.state.sortOrder);
    this.setState({ sortedBy: e.currentTarget.value });
  };

  sortOrder = (e) => {
    this.sortList(this.state.sortedBy, e.currentTarget.value);
    this.setState({ sortOrder: e.currentTarget.value });
  };

  render() {
    const tileEvent = () => {
      this.setState({
        displayType: "tile",
      });
    };

    const listEvent = () => {
      this.setState({
        displayType: "list",
      });
    };

    const data = this.props;
    let sort_label = Helpers.getLanguageFromUrl() === "en" ? "Sort by" : "Sortuj po";
    const paginationType = data.pagination_type;
    let paginationList;

    // COMPOSITIONS
    const compositionList = (
      <div id="list-container" className="composition-list">
        {this.state.pagination_list.map((pagination_item, index) => (
          <div className="composition-item" key={index}>
            <Link
              to={
                pagination_item &&
                pagination_item.button &&
                pagination_item.button.link
                  ? pagination_item.button.link
                  : ""
              }
            >
              <div
                className="item-title"
                dangerouslySetInnerHTML={this.createMarkup(
                  pagination_item && pagination_item.text
                    ? pagination_item.text
                    : null
                )}
              />
            </Link>
            <div>
              {pagination_item.lead ? (
                <div
                  dangerouslySetInnerHTML={{ __html: pagination_item.lead }}
                ></div>
              ) : null}
            </div>
            <div>
              {pagination_item.year ? (
                <div
                  dangerouslySetInnerHTML={{ __html: pagination_item.year }}
                ></div>
              ) : null}
            </div>
            <div className="audio-wrapper">
              {pagination_item.audio ? (
                <div>
                  <MiniAudioPlayer 
                    src={pagination_item.audio} 
                    isPlaying={this.state.activeAudioIndex === index}
                    onPlayStateChange={() => this.handleAudioPlay(index)}
                  />
                </div>
              ) : null}
            </div>
          </div>
        ))}
      </div>
    );

    // EDITIONS
    const editionsList = this.state.pagination_list.map((elem, index) => {
      const url = new URL(window.location.href);
      const searchParam = url.searchParams.get("search");
      let fullText = elem.full_text;
      // fullText = fullText.split("test");
      // console.log(fullText)

      return (
        <div
          className="row iconography__data"
          key={index}
          style={{ textAlign: "left" }}
        >
          <div className="col-lg-12 list-photo">
            <img src={elem.photo} aria-label="list photo" />
          </div>
          {elem.column_0 ? (
            <div
              className="col-lg-1 list-id"
              dangerouslySetInnerHTML={{ __html: elem.column_0 }}
            ></div>
          ) : null}

          {elem.button && elem.button.link ? (
            <div className="col-lg-3 list-title">
              <Link className="tile-link" to={elem.button.link}>
                <span dangerouslySetInnerHTML={{ __html: elem.column_1 }} />
              </Link>
            </div>
          ) : (
            <div
              className="col-lg-3 list-title"
              dangerouslySetInnerHTML={{ __html: elem.column_1 }}
            ></div>
          )}

          {elem.column_2_url ? (
            <Link className="list-autor-url" to={elem.column_2_url}>
              <div
                className="col-lg-3 list-autor"
                dangerouslySetInnerHTML={{ __html: elem.column_2 }}
              ></div>
            </Link>
          ) : (
            <div
              className="col-lg-3 list-autor"
              dangerouslySetInnerHTML={{ __html: elem.column_2 }}
            ></div>
          )}
          {elem.senders && elem.senders.length ? (
            <div className="col-lg-2 list-date">
              {elem.senders.map(function (sender, senderIndex) {
                return (
                  <div key={senderIndex}>
                    {sender.url && sender.url.length ? (
                      <a href={sender.url}>{sender.name}</a>
                    ) : (
                      <div>{sender.name}</div>
                    )}
                  </div>
                );
              })}
            </div>
          ) : elem.column_3 ? (
            <div
              className="col-lg-2 list-date"
              dangerouslySetInnerHTML={{ __html: elem.column_3 }}
            ></div>
          ) : (
            <div className="col-lg-2 list-date"></div>
          )}

          {elem.addressees && elem.addressees.length ? (
            <div className="col-lg-3 list-type">
              {elem.addressees.map(function (addressee, addresseeIndex) {
                return (
                  <div key={addresseeIndex}>
                    {addressee.url && addressee.url.length ? (
                      <a className="list-type-url" href={addressee.url}>
                        {addressee.name}
                      </a>
                    ) : (
                      <div>{addressee.name}</div>
                    )}
                  </div>
                );
              })}
            </div>
          ) : elem.column_4 ? (
            <div
              className="col-lg-3 list-type"
              dangerouslySetInnerHTML={{ __html: elem.column_4 }}
            ></div>
          ) : (
            <div className="col-lg-3 list-type"></div>
          )}

          {
            <div className="col-lg-12 custom-text">
              <Link to={elem.button.link} aria-label="custom text">
                <div dangerouslySetInnerHTML={{ __html: elem.text }}></div>
              </Link>
            </div>
          }

          {elem.button && elem.button.link ? (
            <div className="middle-addelem btn-tile">
              <Link to={elem.button.link} className="vt2 more_button" aria-label="more button">
                {" "}
              </Link>
            </div>
          ) : null}
        </div>
      );
    });

    //  MANUSCRIPTS

    // COMPOSITIONS
    const manuscriptsList = (
      <div>
        {data.switch_text ? (
          <div className="iconography__search-wrapper iconography__search-wrapper--grid manuscript-switch">
            <div>
              <p
                style={{
                  paddingTop: "5px",
                  margin: "0",
                  display: "inline-block",
                }}
              >
                {data.switch_text}
              </p>
              <button
                className={`iconography__text ${
                  this.state.displayType === "tile" ? "selected" : ""
                }`}
                onClick={tileEvent}
                id="tile-btn"
              >
                <img src={tileIcon} />
                {data.switch_tilies_text ? (
                  <span className="link-name">{data.switch_tilies_text}</span>
                ) : null}
              </button>
              <button
                className={`iconography__text ${
                  this.state.displayType === "list" ? "selected" : ""
                }`}
                onClick={listEvent}
                id="list-btn"
              >
                <img src={listIcon} />
                {data.switch_list_text ? (
                  <span className="link-name">{data.switch_list_text}</span>
                ) : null}
              </button>
            </div>
            <div>
              {data.column_1 && data.column_2 ? (
                <div className="custom-sort-section test1">
                  <p>{sort_label}</p>
                  <select
                    name="sortType"
                    id="sortType"
                    onChange={this.sortUpdate}
                  >
                    {data.sort_list.map((item, index) => {
                      return (
                        <option key={index} value={item.sort}>
                          {item.text}
                        </option>
                      );
                    })}
                  </select>
                </div>
              ) : null}
            </div>
          </div>
        ) : (
          <div className="iconography__search-wrapper iconography__search-wrapper--grid manuscript-switch">
            <div></div>
            <div>
              {data.column_1 && data.column_2 && data.column_3 ? (
                <div className="custom-sort-section test2">
                  <p>{sort_label}</p>
                  <select
                    name="sortType"
                    id="sortType"
                    onChange={this.sortUpdate}
                  >
                    {data.sort_list.map((item, index) => {
                      return (
                        <option key={index} value={item.sort}>
                          {item.text}
                        </option>
                      );
                    })}
                  </select>
                </div>
              ) : null}
            </div>
          </div>
        )}
        <div
          id="list-container"
          className={`manuscripts-list ${this.state.displayType}`}
        >
          {data.column_1 && data.column_2 && data.column_3 ? (
            <div className="content-wrapper subtable-header">
              <div>{data.column_1}</div>
              <div>{data.column_2}</div>
              <div>{data.column_3}</div>
            </div>
          ) : null}

          {this.state.pagination_list.map((pagination_item, index) => (
            <div key={index}>
              <Link
                to={
                  pagination_item &&
                  pagination_item.button &&
                  pagination_item.button.link
                    ? pagination_item.button.link
                    : ""
                }
              >
                <div className="content-wrapper">
                  <div
                    className="ChopinLists__text-button"
                    dangerouslySetInnerHTML={this.createMarkup(
                      pagination_item && pagination_item.column_1
                        ? pagination_item.column_1
                        : null
                    )}
                  />
                  <div
                    className="ChopinLists__sub-title"
                    dangerouslySetInnerHTML={this.createMarkup(
                      pagination_item && pagination_item.column_2
                        ? pagination_item.column_2
                        : null
                    )}
                  ></div>
                  <div
                    className="ChopinLists__sub-title"
                    dangerouslySetInnerHTML={this.createMarkup(
                      pagination_item && pagination_item.column_3
                        ? pagination_item.column_3
                        : null
                    )}
                  ></div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    );

    const filmographyList = (
      <div>
        {data.switch_text ? (
          <div className="iconography__search-wrapper iconography__search-wrapper--grid manuscript-switch">
            <div>
              <p
                style={{
                  paddingTop: "5px",
                  margin: "0",
                  display: "inline-block",
                }}
              >
                {data.switch_text}
              </p>
              <button
                className={`iconography__text ${
                  this.state.displayType === "tile" ? "selected" : ""
                }`}
                onClick={tileEvent}
                id="tile-btn"
              >
                <img src={tileIcon} />
                {data.switch_tilies_text ? (
                  <span className="link-name">{data.switch_tilies_text}</span>
                ) : null}
              </button>
              <button
                className={`iconography__text ${
                  this.state.displayType === "list" ? "selected" : ""
                }`}
                onClick={listEvent}
                id="list-btn"
              >
                <img src={listIcon} />
                {data.switch_list_text ? (
                  <span className="link-name">{data.switch_list_text}</span>
                ) : null}
              </button>
            </div>
            <div>
              {data.column_0 && data.column_1 && data.column_2 ? (
                <div className="custom-sort-section test3">
                  <p>{sort_label}</p>
                  <select
                    name="sortType"
                    id="sortType"
                    onChange={this.sortUpdate}
                  >
                    {data.sort_list.map((item, index) => {
                      return (
                        <option key={index} value={item.sort}>
                          {item.text}
                        </option>
                      );
                    })}
                  </select>
                </div>
              ) : null}
            </div>
          </div>
        ) : (
          <div className="iconography__search-wrapper iconography__search-wrapper--grid manuscript-switch">
            <div></div>
            <div>
              {data.column_0 && data.column_1 && data.column_2 ? (
                <div className="custom-sort-section test4">
                  <p>{sort_label}</p>
                  <select
                    name="sortType"
                    id="sortType"
                    onChange={this.sortUpdate}
                  >
                    {data.sort_list.map((item, index) => {
                      return (
                        <option key={index} value={item.sort}>
                          {item.text}
                        </option>
                      );
                    })}
                  </select>
                </div>
              ) : null}
            </div>
          </div>
        )}
        <div className={`list__container--custom ${this.state.displayType}`}>
          {data.column_0 && data.column_1 && data.column_2 ? (
            <div
              className={`content-wrapper subtable-header ${
                data.column_3 ? "grid-4" : ""
              }`}
            >
              <div>{data.column_0}</div>
              <div>{data.column_1}</div>
              <div>{data.column_2}</div>
              {data.column_3 ? <div>{data.column_3}</div> : null}
            </div>
          ) : null}
          {this.state.pagination_list.map((item, index) => {
            if (!item.button) {
              return (
                <div key={index} className="list__item--custom">
                  {item.column_0 ? (
                    <div
                      className="title"
                      dangerouslySetInnerHTML={{ __html: item.column_0 }}
                    ></div>
                  ) : null}
                  {item.column_1 ? (
                    <div>
                      <span className="subtitle">Rodzaj: </span>
                      {item.column_1}
                    </div>
                  ) : null}
                </div>
              );
            } else {
              return (
                <div
                  key={index}
                  className={`list__item--custom ${
                    data.column_3 ? "grid-4" : ""
                  }`}
                >
                  <div>
                    {item.column_0 ? (
                      <div className="title">
                        {item.button && item.button.link ? (
                          <Link to={item.button.link}>{item.column_0}</Link>
                        ) : (
                          item.column_0
                        )}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    {item.column_1 ? (
                      <div>
                        <span className="subtitle">
                          {data.column_1 ? `${data.column_1}: ` : null}
                        </span>
                        {item.column_1}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    {item.column_2 && item.column_2.length > 0 ? (
                      <div>
                        <span className="subtitle">
                          {data.column_2 ? `${data.column_2}: ` : null}
                        </span>
                        {item.column_2_url ? (
                          <a href={item.column_2_url}>{item.column_2}</a>
                        ) : (
                          item.column_2
                        )}
                      </div>
                    ) : null}
                  </div>

                  {data.column_3 ? (
                    <div>
                      {item.column_3 && item.column_3.length > 0 ? (
                        <div>{item.column_3}</div>
                      ) : null}
                    </div>
                  ) : null}

                  <div className="tile-custom-button">
                    {item.button && item.button.link ? (
                      <div>
                        {this.state.displayType == "list" ? null : (
                          <Link
                            className="more_button pagination-button-fix"
                            to={item.button.link}
                          ></Link>
                        )}
                      </div>
                    ) : null}
                  </div>
                </div>
              );
            }
          })}
        </div>
      </div>
    );

    // LOADING BUTTON
    const moreButton =
      data.button_lazy_load &&
      !(data.pagination_list.length < data.items_per_page) ? (
        <button
          style={{ background: window.globalColor }}
          className={`button-load-news ${this.state.morePagination}`}
          onClick={this.updateHandler}
        >
          {data.button_lazy_load
            ? data.button_lazy_load.text
            : "Pokaż kolejne rekordy"}
        </button>
      ) : null;

    // TYPE OF LIST
    switch (paginationType) {
      case "compositions":
        paginationList = compositionList;
        break;
      case "first_edition":
      case "letters":
      case "bibliography":
        paginationList = editionsList;
        break;
      case "manuscripts":
        paginationList = manuscriptsList;
        break;
      case "filmography":
        paginationList = filmographyList;
    }

    return (
      <div>
        <div>{paginationList}</div>
        <div className="pagination__wrapper--function">
          {this.state.loading ? <Spinner /> : moreButton}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Elements/PaginationList/index.jsx